export default {
  namespaced: true,
  directory: {
    title: "Directorio",
    name: "Nombre",
    position: "Cargo",
    phone1: "Teléfono 1",
    phone2: "Teléfono 2",
  },
};